import { useState } from "react";
import { Ban } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { INVITE_STATUS, ROLE_LABELS, formatDate } from "@/lib/labels";
import { EmptyState, StatusBadge } from "./States";
import { ConfirmReasonDialog } from "./ConfirmReasonDialog";

export const InvitationTable = ({ items, onRevoke, canRevoke = () => true }) => {
  const [target, setTarget] = useState(null);
  if (!items.length) return <EmptyState title="Belum ada undangan" description="Masukkan email penerima di atas untuk membuat tautan undangan pertama." />;
  const revokeBtn = (i, suffix = "") => i.status === "pending" && canRevoke(i) && (
    <Button size="sm" variant="outline" onClick={() => setTarget(i)} data-testid={`invitation-revoke-${i.id}${suffix}`}>
      <Ban className="h-3.5 w-3.5 mr-1" /> Cabut
    </Button>
  );
  return (
    <>
      <ul className="md:hidden space-y-3" data-testid="invitation-cards">
        {items.map((i) => (
          <li key={i.id} className="rounded-xl border bg-card p-4 space-y-2">
            <div className="flex items-start justify-between gap-2">
              <p className="font-semibold text-sm break-all">{i.email}</p>
              <StatusBadge map={INVITE_STATUS} value={i.status} />
            </div>
            <p className="text-xs text-muted-foreground">{ROLE_LABELS[i.role]} · berlaku hingga {formatDate(i.expires_at)}</p>
            {revokeBtn(i, "-m")}
          </li>
        ))}
      </ul>
      <div className="hidden md:block rounded-xl border overflow-x-auto">
        <Table data-testid="invitation-table">
          <TableHeader>
            <TableRow><TableHead>Email</TableHead><TableHead>Peran</TableHead><TableHead>Status</TableHead><TableHead>Dibuat</TableHead><TableHead>Berlaku hingga</TableHead><TableHead className="text-right">Tindakan</TableHead></TableRow>
          </TableHeader>
          <TableBody>
            {items.map((i) => (
              <TableRow key={i.id} data-testid={`invitation-row-${i.id}`}>
                <TableCell className="font-medium">{i.email}</TableCell>
                <TableCell>{ROLE_LABELS[i.role]}</TableCell>
                <TableCell><StatusBadge map={INVITE_STATUS} value={i.status} testId={`invitation-status-${i.id}`} /></TableCell>
                <TableCell className="text-xs">{formatDate(i.created_at)}</TableCell>
                <TableCell className="text-xs">{formatDate(i.expires_at)}</TableCell>
                <TableCell className="text-right">{revokeBtn(i)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <ConfirmReasonDialog open={!!target} onOpenChange={(o) => !o && setTarget(null)} danger testId="revoke-invitation-dialog"
        title="Cabut undangan?" description={target ? `Undangan untuk ${target.email} tidak akan bisa digunakan lagi.` : ""}
        confirmLabel="Cabut undangan" onConfirm={(reason) => onRevoke(target, reason)} />
    </>
  );
};
